import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'currency-converter',
    name: "Currency Converter Card",
    description: 'A widget to convert currencies',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-currency-converter" */ "./CurrencyConverter")),
    icon: generateIconProp('tachometerAlt'),
    complexity: 'medium',
});
